import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'
import Con from '../../static/config.json'

Vue.use(Vueaxios, axios)
const URL = Con.URL
export default {
  getZone (obj, header, success, error) {
    Vue.axios.post(URL + 'homezone/search', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  searchVillages (obj, header, success, error) {
    Vue.axios.post(URL + 'home/search', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  addVillage (obj, header, success, error) {
    Vue.axios.post(URL + 'home', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  editVillage (obj, header, success, error) {
    Vue.axios.put(URL + 'home', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  deleteVillage (id, header, success, error) {
    Vue.axios.delete(URL + 'home/' + id, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/service_village.js